import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const LocationTargeting = ({ locations, targetOption }) => {
  const i18n = useContext(I18nContext);

  const explicitLocations = useMemo(() => {
    const numLocations = locations.length;

    if (targetOption === 'everywhere') {
      return i18n.getString(_TL_('Everywhere'));
    }

    if (numLocations === 1) {
      return locations[0];
    } else if (numLocations === 2) {
      return `${locations[0]}, ${locations[1]}`;
    } else if (numLocations >= 3) {
      const moreThan2LocationsTemplate = _TL_('{0} +{1} more', 'The {0} placeholder represents the first location. The {1} placeholder represents the number of remaining locations');
      return i18n.getString(moreThan2LocationsTemplate).replace('{0}', locations[0]).replace('{1}', numLocations - 1);
    }
    return null;
  }, [i18n, locations, targetOption]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Location') }}>
      <Text>{explicitLocations}</Text>
    </PropertyRow>
  );
};

LocationTargeting.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.string),
  targetOption: PropTypes.string,
};

LocationTargeting.defaultProps = {
  locations: [],
  targetOption: null,
};
